/**
 * Erst-Hinweis für Auswertungslisten.
 *
 * Der dezente „Tipp"-Balken in der FilterBar wird angezeigt, bis der Benutzer
 * das erste Mal eine Hilfe (HelpPopover oder den „Verstanden"-Button) benutzt.
 * Danach dauerhaft ausgeblendet (localStorage, pro Browser/Benutzerprofil).
 *
 * Ein CustomEvent sorgt dafür, dass ein evtl. zweiter gemounteter Balken
 * (theoretisch) sofort verschwindet, ohne dass die Seite neu geladen wird.
 */

const STORAGE_KEY = 'symphenia_listhelp_seen'
const EVENT_NAME = 'symphenia:listhelp-seen'

export function isListHelpSeen(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function markListHelpSeen(): void {
  try {
    if (localStorage.getItem(STORAGE_KEY) === '1') return
    localStorage.setItem(STORAGE_KEY, '1')
  } catch {
    // ignore (z.B. Private-Mode) – Balken erscheint dann evtl. erneut, unkritisch
  }
  window.dispatchEvent(new CustomEvent(EVENT_NAME))
}

/** Abonniert Änderungen; gibt eine Cleanup-Funktion zurück. */
export function onListHelpSeen(cb: () => void): () => void {
  window.addEventListener(EVENT_NAME, cb)
  return () => window.removeEventListener(EVENT_NAME, cb)
}
